import { Label } from '@/components/ui/label';
import { useTRPC } from '@/trpc';
import { useQuery } from '@tanstack/react-query';

interface Props {
    contact_id: string;
}

const Overview = ({ contact_id }: Props) => {
    const { trpc } = useTRPC();

    const { data:contact } = useQuery({
        queryKey: ['contact', contact_id],
        queryFn: async () => {
            const contact = await trpc.contacts.search.query({
                id: contact_id
            })
            return contact[0];
        },
    })

  return (
    <div className='bg-foreground/10 rounded-lg p-4 grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4'>
        <div>
            <Label>Naam</Label>
            <p>{contact?.contact_name}</p>
        </div>
        <div>
            <Label>Bedrijfsnaam</Label>
            <p>{contact?.company_name}</p>
        </div>
        <div>
            <Label>Email</Label>
            <p>{contact?.email}</p>
        </div>
        <div>
            <Label>Telefoon</Label>
            <p>{contact?.telephone}</p>
        </div>
        <div>
            <Label>Contact via</Label>
            <p>{contact?.contact_via?.join(', ')}</p>
        </div>
        <div>
            <Label>Notitie</Label>
            <p>{contact?.note}</p>
        </div>
        <div>
            <Label>Betrouwbaarheid</Label>
            <p>{contact?.reliability}</p>
        </div>
        <div>
            <Label>Kwaliteit spelers</Label>
            <p>{contact?.quality_players}</p>
        </div>
    </div>
  )
}

export default Overview